import { checkauth } from '../Helper';

// Pagine comuni alle sezioni Amazon ed eBay (stesse view, la piattaforma arriva da meta.platform):
// Regole feed e Repricing, raggiunte dalle schede sotto il titolo (components/marketplace/MarketplaceTabs).
const FeedRules = () => import('../views/marketplace/FeedRules.vue');
const FeedRuleForm = () => import('../views/marketplace/FeedRuleForm.vue');
const Repricing = () => import('../views/marketplace/Repricing.vue');
const RepricingRuleForm = () => import('../views/marketplace/RepricingRuleForm.vue');

const auth = (to, from, next) => {
	checkauth().then(response => (response ? next() : next('/login')));
};

export default platform => [
	{ path: `/${platform}/regole`, name: `${platform}-rules`, component: FeedRules, meta: { platform }, beforeEnter: auth },
	{ path: `/${platform}/regole/nuova`, name: `${platform}-rule-new`, component: FeedRuleForm, meta: { platform }, beforeEnter: auth },
	{ path: `/${platform}/regole/:id`, name: `${platform}-rule-edit`, component: FeedRuleForm, meta: { platform }, beforeEnter: auth },
	{ path: `/${platform}/repricing`, name: `${platform}-repricing`, component: Repricing, meta: { platform }, beforeEnter: auth },
	{ path: `/${platform}/repricing/regole/nuova`, name: `${platform}-repricing-rule-new`, component: RepricingRuleForm, meta: { platform }, beforeEnter: auth },
	{ path: `/${platform}/repricing/regole/:id`, name: `${platform}-repricing-rule-edit`, component: RepricingRuleForm, meta: { platform }, beforeEnter: auth },
];
